module.exports = __webpack_public_path__ + "assets/img/donate-share-pic.09dd286a.png";